<div class="row bg-first">
    <div class="col-xl-12">
        <div class="row">
            <div class="col-xl-8" style="border: 1px solid red">
                <h1>MAKE IT PUBLIC</h1><br />
                <h4 style="width: 60%">You can now make your charging stations available to drivers in your area.
                    Drivers will cover electricity costs and pay fees for your charging service.</h4>
                <button nbButton status="info" class="btn btn-margin">Admin start</button>
                <div class="col-xl-12 text-center phone-container"><img class="phone-img" src="./assets/img/macbook.png"
                        alt="">
                </div>
            </div>
            <div class="col-xl-4" style="border: 1px solid green">
                <div class="col-xl-12 text-center phone-container"><img class="phone-img" src="./assets/img/iphone6.png"
                        alt="">
                </div>
            </div>
        </div>
    </div>